<div class="t2d-tree-picker__backdrop" role="dialog" aria-modal="true" (click)="onBackdropClick($event)">
  <div class="t2d-tree-picker">
    <div class="t2d-tree-picker__header">
      <ul class="t2d-tree-picker__tabs" role="tablist">
        <li>
          <button
            type="button"
            role="tab"
            [attr.aria-selected]="activeTab() === 'projektbaum'"
            [class.active]="activeTab() === 'projektbaum'"
            (click)="selectTab('projektbaum')"
          >
            Projekt-Baum
          </button>
        </li>
        <li>
          <button
            type="button"
            role="tab"
            [attr.aria-selected]="activeTab() === 'organisation'"
            [class.active]="activeTab() === 'organisation'"
            (click)="selectTab('organisation')"
          >
            Organisationen
          </button>
        </li>
        <li>
          <button
            type="button"
            role="tab"
            [attr.aria-selected]="activeTab() === 'ansprechpartner'"
            [class.active]="activeTab() === 'ansprechpartner'"
            (click)="selectTab('ansprechpartner')"
          >
            Ansprechpartner
          </button>
        </li>
        <li>
          <button
            type="button"
            role="tab"
            [attr.aria-selected]="activeTab() === 'bestandsknoten'"
            [class.active]="activeTab() === 'bestandsknoten'"
            (click)="selectTab('bestandsknoten')"
          >
            Liegenschaften
          </button>
        </li>
      </ul>
      <button type="button" class="t2d-tree-picker__close" aria-label="Picker schließen" (click)="close()">✕</button>
    </div>

    <div class="t2d-tree-picker__body">
      @switch (activeTab()) {
        @case ('projektbaum') {
          <div class="t2d-tree-picker__panel" data-tab="projektbaum">
            <input type="search" class="t2d-tree-picker__search" placeholder="Eintrag suchen…" (input)="onProjektbaumQuery($any($event.target).value)" />

            @if (searchActive()) {
              <ul class="t2d-tree-picker__hits">
                @for (hit of searchHits(); track hit.type + ':' + hit.item.id) {
                  <li class="t2d-tree-picker__hit">
                    <span class="t2d-tree-picker__hit-type">{{ entityTypeLabel(hit.type) }}</span>
                    <span class="t2d-tree-picker__hit-label" [title]="hit.item.label">{{ shortLabel(hit.item.label) }}</span>
                    <button type="button" aria-label="Auswählen" (click)="pickHit(hit)">＋</button>
                  </li>
                } @empty {
                  <li class="t2d-tree-picker__hint">Keine Treffer</li>
                }
              </ul>
            } @else {
              @if (rootsLoading()) {
                <div class="t2d-tree-picker__hint">Lade…</div>
              } @else if (rootsError()) {
                <div class="t2d-tree-picker__hint">
                  Laden fehlgeschlagen.
                  <button type="button" (click)="retryRoots()">Erneut versuchen</button>
                </div>
              } @else {
                <ul class="t2d-tree">
                  @for (node of roots(); track node.item.id) {
                    <ng-container *ngTemplateOutlet="treeNodeTpl; context: { $implicit: node, depth: 0 }" />
                  }
                </ul>
              }
            }
          </div>
        }
        @case ('organisation') {
          <div class="t2d-tree-picker__panel" data-tab="organisation">
            <input type="search" class="t2d-tree-picker__search" placeholder="Organisation suchen…" (input)="onFlatQuery($any($event.target).value)" />
            <ul class="t2d-tree-picker__hits">
              @if (flatLoading()) {
                <li class="t2d-tree-picker__hint">Lade…</li>
              } @else {
                @for (item of flatResults(); track item.id) {
                  <li class="t2d-tree-picker__hit">
                    <span class="t2d-tree-picker__hit-label">{{ item.label }}</span>
                    <button type="button" aria-label="Auswählen" (click)="pickFlat('organisation', item)">＋</button>
                  </li>
                } @empty {
                  <li class="t2d-tree-picker__hint">Keine Einträge</li>
                }
              }
            </ul>
          </div>
        }
        @case ('ansprechpartner') {
          <div class="t2d-tree-picker__panel" data-tab="ansprechpartner">
            <input type="search" class="t2d-tree-picker__search" placeholder="Ansprechpartner suchen…" (input)="onFlatQuery($any($event.target).value)" />
            <ul class="t2d-tree-picker__hits">
              @if (flatLoading()) {
                <li class="t2d-tree-picker__hint">Lade…</li>
              } @else {
                @for (item of flatResults(); track item.id) {
                  <li class="t2d-tree-picker__hit">
                    <span class="t2d-tree-picker__hit-label">{{ item.label }}</span>
                    <button type="button" aria-label="Auswählen" (click)="pickFlat('ansprechpartner', item)">＋</button>
                  </li>
                } @empty {
                  <li class="t2d-tree-picker__hint">Keine Einträge</li>
                }
              }
            </ul>
          </div>
        }
        @case ('bestandsknoten') {
          <div class="t2d-tree-picker__panel" data-tab="bestandsknoten">
            @if (bkRootsLoading()) {
              <div class="t2d-tree-picker__hint">Lade…</div>
            } @else if (bkRootsError()) {
              <div class="t2d-tree-picker__hint">
                Laden fehlgeschlagen.
                <button type="button" (click)="retryBkRoots()">Erneut versuchen</button>
              </div>
            } @else {
              <ul class="t2d-tree">
                @for (node of bkRoots(); track node.data.id) {
                  <ng-container *ngTemplateOutlet="bkNodeTpl; context: { $implicit: node, depth: 0 }" />
                }
              </ul>
            }
          </div>
        }
      }
    </div>
  </div>
</div>

<ng-template #bkNodeTpl let-node let-depth="depth">
  <li class="t2d-tree__node" [style.paddingLeft.rem]="depth">
    <div class="t2d-tree__row">
      @if (bkHasChildren(node.data.typ)) {
        <button type="button" class="t2d-tree__toggle" [attr.aria-expanded]="node.expanded" (click)="bkToggleExpand(node)">
          {{ node.expanded ? '▾' : '▸' }}
        </button>
      } @else {
        <span class="t2d-tree__toggle t2d-tree__toggle--leaf"></span>
      }
      <span class="t2d-tree__type">{{ bkTypLabel(node.data.typ) }}</span>
      <span class="t2d-tree__label" [title]="node.data.pfad.join(' / ')">{{ node.data.bezeichnung }}</span>
      <button type="button" class="t2d-tree__pick" [attr.aria-label]="'auswählen'" (click)="pickBestandsknoten(node)">＋</button>
    </div>

    @if (node.expanded) {
      @if (node.loading) {
        <div class="t2d-tree__hint">Lade…</div>
      } @else if (node.error) {
        <div class="t2d-tree__hint">
          Fehler.
          <button type="button" (click)="retryBkNode(node)">Erneut</button>
        </div>
      } @else if (node.children !== null && node.children.length === 0) {
        <div class="t2d-tree__hint">Keine Einträge</div>
      } @else if (node.children !== null) {
        <ul class="t2d-tree">
          @for (child of node.children; track child.data.id) {
            <ng-container *ngTemplateOutlet="bkNodeTpl; context: { $implicit: child, depth: depth + 1 }" />
          }
        </ul>
      }
    }
  </li>
</ng-template>

<ng-template #treeNodeTpl let-node let-depth="depth">
  <li class="t2d-tree__node" [style.paddingLeft.rem]="depth">
    <div class="t2d-tree__row">
      @if (hasChildren(node.type)) {
        <button type="button" class="t2d-tree__toggle" [attr.aria-expanded]="node.expanded" (click)="toggleExpand(node)">
          {{ node.expanded ? '▾' : '▸' }}
        </button>
      } @else {
        <span class="t2d-tree__toggle t2d-tree__toggle--leaf"></span>
      }
      <span class="t2d-tree__type">{{ entityTypeLabel(node.type) }}</span>
      <span class="t2d-tree__label" [title]="node.item.label">{{ shortLabel(node.item.label) }}</span>
      <button type="button" class="t2d-tree__pick" [attr.aria-label]="'auswählen'" (click)="pick(node)">＋</button>
    </div>

    @if (node.expanded) {
      @if (node.loading) {
        <div class="t2d-tree__hint">Lade…</div>
      } @else if (node.error) {
        <div class="t2d-tree__hint">
          Fehler.
          <button type="button" (click)="retryNode(node)">Erneut</button>
        </div>
      } @else if (node.children !== null && node.children.length === 0) {
        <div class="t2d-tree__hint">Keine Einträge</div>
      } @else if (node.children !== null) {
        <ul class="t2d-tree">
          @for (child of node.children; track child.item.id) {
            <ng-container *ngTemplateOutlet="treeNodeTpl; context: { $implicit: child, depth: depth + 1 }" />
          }
        </ul>
      }
    }
  </li>
</ng-template>
